import React from 'react'
import styled from 'styled-components'
import { Colors } from '../../configs/styled.config'
import { Column } from '../../shared/shared.styled'
import { Typography } from '../../configs/styled.config'
import UploadLogo from './upload-logo.component'
import { Event as CompanyEvent } from '../../shared/shared.models'
import { AdminApi } from '../admin.api'
import { useFormikContext } from 'formik'
import { CreateEventRequest } from '../admin.interfaces'

interface EventPhotoProps {
    event: CompanyEvent
}

export const EventPhoto = ({ event }: EventPhotoProps) => {
    // Reads/writes values.imageUrl (not the event prop) so the preview
    // updates immediately after a successful upload, without needing a
    // redux slice for events (see CompanyPhoto for that heavier pattern).
    const { values, setFieldValue } = useFormikContext<CreateEventRequest>()
    const [isUploading, setIsUploading] = React.useState(false)

    function uploadFile(file: File) {
        return new Promise<void>(async (resolve, reject) => {
            setIsUploading(true)
            try {
                const res = await AdminApi.methods.uploadEventImage(
                    event.uuid,
                    file
                )
                setFieldValue('imageUrl', res.data.event.imageUrl)
                resolve()
            } catch (e) {
                reject()
            } finally {
                setIsUploading(false)
            }
        })
    }

    return (
        <Column style={{ width: '100%' }}>
            <StyledTitle>Imagem do evento</StyledTitle>
            {values.imageUrl ? (
                <ContainerImage>
                    <Image src={values.imageUrl} />
                    <UploadLogo
                        isUploading={isUploading}
                        handleUpload={uploadFile}
                    />
                </ContainerImage>
            ) : (
                <Container>
                    <Description>Este evento ainda não tem imagem.</Description>
                    <Description>
                        Enquanto não houver upload, o site público usa a imagem
                        genérica.
                    </Description>
                    <UploadLogo
                        isUploading={isUploading}
                        handleUpload={uploadFile}
                    />
                </Container>
            )}
        </Column>
    )
}

const ContainerImage = styled(Column as any)`
    flex-shrink: 1;
    max-width: 320px;
    height: auto;
    border-radius: 6px;
    border: 1px solid #d8d8d8;

    @media screen and (max-width: 767px) {
        width: 100%;
    }
`

const Container = styled(Column as any)`
    flex-shrink: 1;
    max-width: 320px;
    height: auto;
    border-radius: 6px;
    border: 1px solid #d8d8d8;

    @media screen and (max-width: 767px) {
        width: 100%;
    }
`

const Description = styled('div')`
    font-family: Merriweather-Light;
    text-align: center;
    font-size: 16px;
    margin: 24px;
    color: ${Colors.dark};
`

const Image = styled('img')`
    max-width: 320px;
`

const StyledTitle = styled('span')`
    font-weight: bold;
    margin-bottom: 8px;
    ${Typography['Body_Text_#1_Regular_Left']};
    font-size: 18px;
    color: #44566c;
`
